import { Description, Dialog, DialogBackdrop, DialogPanel, DialogTitle } from "@headlessui/react";
import CategoryCard from "./CategoryCard";

const CategoryResultModal = ({ isOpen, setIsOpen, handleModalAction, category, getResutlDescription }) => {
  if (!category) {
    return null;
  }

  return (
    <Dialog
      open={isOpen}
      onClose={() => setIsOpen(false)}
      transition
      className="category-result-modal relative z-50 transition duration-300 ease-out data-[closed]:opacity-0">
      <DialogBackdrop className="fixed inset-0 bg-black/70 " />
      <div className="fixed inset-0 flex w-screen md:items-center justify-center p-4">
        <DialogPanel
          className="w-full max-w-2xl space-y-4 border bg-white p-4 rounded-xl overflow-hidden"
          style={{ backgroundColor: category.color }}>
          <div className="flex justify-end">
            <button type="button" className="modal-close-btn" onClick={() => setIsOpen(false)}>
              <svg
                className="fill-neutral-200 hover:fill-white transition ease-in-out duration-150 "
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 48 48"
                width="30px"
                height="30px">
                <path d="M 39.486328 6.9785156 A 1.50015 1.50015 0 0 0 38.439453 7.4394531 L 24 21.878906 L 9.5605469 7.4394531 A 1.50015 1.50015 0 0 0 8.484375 6.984375 A 1.50015 1.50015 0 0 0 7.4394531 9.5605469 L 21.878906 24 L 7.4394531 38.439453 A 1.50015 1.50015 0 1 0 9.5605469 40.560547 L 24 26.121094 L 38.439453 40.560547 A 1.50015 1.50015 0 1 0 40.560547 38.439453 L 26.121094 24 L 40.560547 9.5605469 A 1.50015 1.50015 0 0 0 39.486328 6.9785156 z" />
              </svg>
            </button>
          </div>
          <div className="modal-content">
            <div className="row flex-col md:flex-row">
              <div className="col">
                <CategoryCard category={category} />
              </div>
              <div className="col">
                <DialogTitle className="font-bold mt-4">
                  {category.title} - {category.score}%
                </DialogTitle>
                <Description>
                  <div dangerouslySetInnerHTML={{ __html: getResutlDescription(category.key, category.score) }}></div>
                  <div className="modal-actions">
                    {/*
                    <button className="ght-button ght-button-modal" onClick={handleModalAction}>
                      <span style={{ color: category.color }}>
                        <strong>Apúntate al reto</strong>
                      </span>
                    </button>
                    */}
                  </div>
                </Description>
              </div>
            </div>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
};

export default CategoryResultModal;
